import React, { useEffect, useRef, useState } from 'react'
import { FormControl, InputGroup} from "react-bootstrap";
import { debounce } from "lodash"
import { SEARCHPARAM } from './ListTrackComponent';

const SearchComponent = (props) => {

    const [searchTerm, setSearchTerm] = useState(props.searchTerm);

    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

  
    const debouncedSearch = useRef(
        debounce(async (value) => {            
            props.setSearchterm(value);
        }, 1000)
    ).current;

    const handleSearchInput = event => {
        setSearchTerm(event.target.value);
        debouncedSearch(event.target.value);
    };

    

    return   (
        <div id="search" className='defaultMargin'>
            <InputGroup className="mb-3" style={{marginTop: '15px'}}>
                <FormControl
                    onInput={handleSearchInput}
                    type="search"
                    className="me-2"
                    aria-label="Search"
                    placeholder="Suche"
                    defaultValue={props.searchTerm}
                >
                </FormControl>
            </InputGroup>
        </div>
    )
}

export default SearchComponent